(function () {
  'use strict';

  var token = 0;
  var pdRoot = function () { return document.querySelector('[data-pd-root]'); };

  var start = function () {
    var CS = window.CS;
    var root = pdRoot();
    if (!CS || !root) return;
    var $ = function (sel, el) { return CS.$(sel, el || root); };
    var $$ = function (sel, el) { return CS.$$(sel, el || root); };
    var info = $('.pd__info');
    var json = $('[data-product-json]', info);
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var addBtn = $('[data-pd-add]');
    var form = $('[data-pd-form]');
    var mainImg = $('.pd__img');
    var sel = 1;
    var variant = data.variants.filter(function (v) { return String(v.id) === info.dataset.variantId; })[0] || data.variants[0];
    var images = variant.images;
    var srcSig = CS.srcSig;

    var refresh = function () {
      if (!variant.available) {
        addBtn.disabled = true;
        addBtn.dataset.state = 'sold';
        addBtn.classList.remove('is-in-cart');
        addBtn.textContent = 'Sold out';
        return;
      }
      addBtn.disabled = false;
      var inCart = CS.Cart.qty(variant.id);
      var state;
      if (!inCart) state = 'add';
      else if (sel === inCart) state = 'in';
      else state = 'update';
      if (addBtn.dataset.state === state) return;
      addBtn.dataset.state = state;
      addBtn.classList.toggle('is-in-cart', state === 'in');
      addBtn.setAttribute('aria-disabled', state === 'in' ? 'true' : 'false');
      addBtn.innerHTML = state === 'in' ? CS.icon('check') + ' In Basket' : CS.icon('basket') + (state === 'update' ? ' Update Basket' : ' Add to Basket');
      if (state === 'in') addBtn.setAttribute('aria-describedby', 'pd-add-tip'); else addBtn.removeAttribute('aria-describedby');
    };
    var setSel = function (n) {
      sel = Math.max(1, Math.min(99, n));
      $('[data-pd-sel-n]').textContent = sel;
      $('[data-pd-qty]').value = sel;
      refresh();
    };

    var warmAll = function (list) {
      (list || images).forEach(function (img) { if (img) CS.warmImage(img.src); });
    };
    var warmSoon = function (list) {
      var run = function () { warmAll(list); };
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 1500 });
      else setTimeout(run, 300);
    };

    var inkAt = 0;
    var inkTo = function (i, retry) {
      inkAt = i;
      var strip = $('[data-pd-thumbs]');
      if (!strip || strip.hidden) return;
      var on = $$('[data-pd-thumb]', strip)[i];
      if (!on) return;
      if (!on.offsetWidth) {
        if (retry !== false) window.requestAnimationFrame(function () { inkTo(i, false); });
        return;
      }
      var ink = $('.pd__thumb-ink', strip);
      var first = !ink;
      if (first) {
        ink = document.createElement('span');
        ink.className = 'pd__thumb-ink is-instant';
        ink.setAttribute('aria-hidden', 'true');
        strip.appendChild(ink);
        strip.classList.add('has-ink');
      }
      ink.style.width = on.offsetWidth + 'px';
      ink.style.height = on.offsetHeight + 'px';
      ink.style.transform = 'translate(' + on.offsetLeft + 'px,' + on.offsetTop + 'px)';
      if (first) {
        ink.getBoundingClientRect();
        window.requestAnimationFrame(function () { ink.classList.remove('is-instant'); });
      }
    };
    var inkRefit = function () {
      if (!root.isConnected) return;
      var ink = $('.pd__thumb-ink');
      if (ink) ink.classList.add('is-instant');
      inkTo(inkAt);
      if (ink) window.requestAnimationFrame(function () { ink.classList.remove('is-instant'); });
    };
    CS.onResize(inkRefit);
    window.addEventListener('load', inkRefit);

    var swapTimer = null;
    var showImage = function (i) {
      var img = images[i];
      if (!img || !mainImg || mainImg.tagName !== 'IMG') return;
      $$('[data-pd-thumb]').forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      inkTo(i);
      var apply = function () {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = img.src;
        mainImg.alt = img.alt;
      };
      if (CS.reduceMotion || mainImg.getAttribute('src') === img.src) { apply(); return; }
      var pre = CS.warmImage(img.src);
      clearTimeout(swapTimer);
      mainImg.classList.add('is-swapping');
      var done = false;
      var show = function () {
        if (done) return;
        done = true;
        clearTimeout(swapTimer);
        apply();
        requestAnimationFrame(function () { mainImg.classList.remove('is-swapping'); });
      };
      if (pre.complete && pre.naturalWidth) {
        if (pre.decode) pre.decode().then(show, show); else show();
      } else {
        pre.addEventListener('load', show, { once: true });
        pre.addEventListener('error', show, { once: true });
        swapTimer = setTimeout(show, 1200);
      }
    };
    var paintGallery = function () {
      var strip = $('[data-pd-thumbs]');
      strip.hidden = images.length < 2;
      $('.pd__gallery').classList.toggle('pd__gallery--single', images.length < 2);
      strip.innerHTML = images.length > 1 ? images.map(function (img, i) {
        return '<button type="button" class="pd__thumb" data-pd-thumb="' + i + '" aria-current="' + (i === 0) + '" aria-label="Show image ' + (i + 1) + ' of ' + images.length + '">' +
          '<img src="' + img.thumb + '" alt="" loading="lazy" width="150" height="150"></button>';
      }).join('') : '';
      showImage(0);
      warmSoon();
    };

    var select = function (v, fromClick) {
      var imagesChanged = srcSig(v.images) !== srcSig(images);
      variant = v;
      info.dataset.variantId = v.id;
      $('[data-pd-id]').value = v.id;
      var sale = v.compare > v.price;
      var price = $('[data-pd-price]');
      price.classList.toggle('pd__price--sale', sale || price.hasAttribute('data-red'));
      price.innerHTML = (sale ? '<s>' + CS.money(v.compare) + '</s> ' : '') + CS.money(v.price);
      var unit = $('[data-pd-unit]');
      unit.dataset.unit = v.size;
      unit.dataset.unitPrice = v.price;
      unit.textContent = v.unit || CS.unitPrice(v.size, v.price);
      $$('[data-pd-size]', document).forEach(function (el) { el.textContent = v.size; });

      var stock = $('[data-pd-stock]');
      stock.removeAttribute('data-out');
      stock.removeAttribute('data-low');
      if (!v.available) { stock.textContent = 'Out of stock'; stock.setAttribute('data-out', ''); }
      else if (v.stock !== null && v.stock > 0 && v.stock <= 5) { stock.textContent = 'Only ' + v.stock + ' left'; stock.setAttribute('data-low', ''); }
      else stock.textContent = 'In stock';

      var badge = $('[data-pd-badge]');
      if (badge && sale) badge.textContent = '-' + Math.floor((v.compare - v.price) * 100 / v.compare) + '%';

      var bundleCurrent = document.querySelector('[data-bundle-current]');
      if (bundleCurrent) {
        bundleCurrent.dataset.bundleId = v.id;
        bundleCurrent.dataset.price = v.price;
        var cp = document.querySelector('[data-bundle-current-price]');
        if (cp) cp.textContent = CS.money(v.price);
        bundleTotal();
      }

      if (imagesChanged && v.images.length) { images = v.images; paintGallery(); }
      else if (v.images.length) warmSoon(v.images);
      $$('[data-pd-option]').forEach(function (b) {
        b.setAttribute('aria-pressed', v.options[Number(b.dataset.pdOption)] === b.dataset.value ? 'true' : 'false');
      });
      if (fromClick && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(null, '', url.toString());
      }
      setSel(CS.Cart.qty(v.id) || 1);
      CS.syncScope(info);
    };

    var bundle = document.querySelector('[data-bundle]');
    var bundleTotal = function () {
      if (!bundle) return;
      var total = 0;
      $$('[data-bundle-id]', bundle).forEach(function (box) {
        box.closest('.bundle-item').classList.toggle('is-checked', box.checked);
        if (box.checked) total += Number(box.dataset.price);
      });
      $('[data-bundle-total]', bundle).textContent = CS.money(total);
      $('[data-bundle-add]', bundle).disabled = total === 0;
    };
    if (bundle) {
      bundle.addEventListener('change', bundleTotal);
      bundle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bundle-add]');
        if (!btn) return;
        var items = $$('[data-bundle-id]:checked', bundle).map(function (box) { return { id: Number(box.dataset.bundleId), quantity: 1 }; });
        if (!items.length) return;
        btn.disabled = true;
        CS.Cart.add(items).then(function () {
          btn.disabled = false;
          btn.innerHTML = CS.icon('check') + ' Added to basket';
          CS.flyToCart($('img', bundle));
          clearTimeout(btn.flashTimer);
          btn.flashTimer = setTimeout(function () { btn.innerHTML = 'Add <span class="bundle__opt">selected </span>to basket'; }, 1600);
        }, function () { btn.disabled = false; });
      });
      bundleTotal();
    }

    var tablist = $('[role="tablist"]');
    var tabsBox = tablist ? tablist.closest('.pd-tabs') : null;
    var ink = null;
    if (tablist && tabsBox) {
      ink = document.createElement('span');
      ink.className = 'pd-tabs__ink';
      ink.hidden = true;
      tabsBox.appendChild(ink);
    }
    var step = 1 / (window.devicePixelRatio || 1);
    var snap = function (v) { return Math.round(v / step) * step; };
    var moveInk = function (animate) {
      if (!ink || !tablist || !tabsBox) return;
      var on = $('[role="tab"][aria-selected="true"]');
      if (!on) { ink.hidden = true; return; }
      if (!animate) ink.style.transition = 'none';
      ink.hidden = false;
      var tabBox = on.getBoundingClientRect();
      var boxRect = tabsBox.getBoundingClientRect();
      var panels = $('.pd-tabs__panels', tabsBox);
      var floor = panels ? panels.getBoundingClientRect().top + 1 : tabBox.bottom;
      var left = snap(tabBox.left) - boxRect.left;
      var right = snap(tabBox.right) - boxRect.left;
      ink.style.width = (right - left) + 'px';
      ink.style.height = Math.max(snap(tabBox.height), snap(floor) - snap(tabBox.top)) + 'px';
      ink.style.top = (snap(tabBox.top) - boxRect.top) + 'px';
      ink.style.transform = 'translateX(' + left + 'px)';
      if (!animate) { ink.offsetWidth; ink.style.transition = ''; }
    };
    var tabKey = function (el) { return el.id.replace('pd-tab-', ''); };
    var tab = function (key, focus) {
      $$('[role="tab"]').forEach(function (t) {
        var on = t.id === 'pd-tab-' + key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      $$('[role="tabpanel"]').forEach(function (p) { p.classList.toggle('is-active', p.id === 'pd-panel-' + key); });
      moveInk(true);
    };
    if (tablist) {
      moveInk(false);
      var lastScroll = tablist.scrollLeft;
      tablist.addEventListener('scroll', function () {
        if (tablist.scrollLeft === lastScroll) return;
        lastScroll = tablist.scrollLeft;
        moveInk(false);
      }, { passive: true });
      var lastW = tablist.offsetWidth;
      var onResize = function () {
        if (tablist.offsetWidth === lastW) return;
        lastW = tablist.offsetWidth;
        moveInk(false);
      };
      if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(tablist);
      else CS.onResize(onResize);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moveInk(false); });
    }
    if (tablist) tablist.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var tabs = $$('[role="tab"]');
      var at = tabs.indexOf(document.activeElement);
      if (at < 0) return;
      e.preventDefault();
      var next = tabs[(at + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      tab(tabKey(next), true);
    });
    var reviewForm = function (open) {
      var wrap = $('[data-review-form]');
      if (!wrap) return;
      var panel = $('[data-review-panel]', wrap);
      var opener = $('[data-review-open]', wrap);
      if (!panel || !opener) return;
      opener.setAttribute('aria-expanded', open ? 'true' : 'false');

      var seed = function () {
        var b = opener.getBoundingClientRect();
        var w = wrap.getBoundingClientRect();
        var p = panel.getBoundingClientRect();
        var r = Math.round(b.height / 2);
        return 'inset(' + Math.max(0, b.top - p.top) + 'px ' +
          Math.max(0, p.right - b.right) + 'px ' +
          Math.max(0, p.bottom - b.bottom) + 'px ' +
          Math.max(0, b.left - p.left) + 'px round ' + r + 'px)';
      };

      if (open) {
        panel.hidden = false;
        var from = seed();
        panel.classList.add('is-closed');
        panel.style.transition = 'none';
        panel.style.clipPath = from;
        panel.offsetWidth;
        panel.style.transition = '';
        panel.classList.add('is-morphing');
        panel.offsetWidth;
        opener.hidden = true;
        panel.style.clipPath = '';
        panel.classList.remove('is-closed');
        window.setTimeout(function () {
          panel.classList.remove('is-morphing');
          var first = $('input, textarea', panel);
          if (first) first.focus({ preventScroll: true });
        }, 380);
      } else {
        opener.hidden = false;
        var to = seed();
        opener.hidden = true;
        panel.classList.add('is-morphing');
        panel.offsetWidth;
        panel.style.clipPath = to;
        panel.classList.add('is-closed');
        window.setTimeout(function () {
          panel.hidden = true;
          panel.classList.remove('is-morphing');
          panel.classList.remove('is-closed');
          panel.style.clipPath = '';
          opener.hidden = false;
          opener.focus({ preventScroll: true });
        }, 360);
      }
    };
    var openReviews = function (openForm) {
      var box = $('#pd-reviews');
      if (box) box.open = true;
      if (openForm) reviewForm(true);
      if (box) box.scrollIntoView({ behavior: CS.reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-review-open]')) { e.preventDefault(); reviewForm(true); }
      else if (e.target.closest('[data-review-close]')) { e.preventDefault(); reviewForm(false); }
    });
    if (/#(reviews|review-form)/.test(window.location.hash)) {
      setTimeout(function () { openReviews(true); }, 60);
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var selBtn = t.closest('[data-pd-sel]');
      if (selBtn) { setSel(sel + Number(selBtn.dataset.pdSel)); return; }
      var option = t.closest('[data-pd-option]');
      if (option) {
        var chosen = variant.options.slice();
        var index = Number(option.dataset.pdOption);
        chosen[index] = option.dataset.value;
        var v = CS.findVariant(data, chosen) || CS.findVariant(data, chosen.map(function (x, i) { return i === index ? x : null; }));
        if (v) select(v, true);
        return;
      }
      var thumb = t.closest('[data-pd-thumb]');
      if (thumb) { showImage(Number(thumb.dataset.pdThumb)); return; }
      var tabBtn = t.closest('[role="tab"]');
      if (tabBtn) { tab(tabKey(tabBtn)); return; }
      if (t.closest('[data-pd-reviews]')) { e.preventDefault(); openReviews(false); }
    });

    var buyBtn = $('[data-pd-buy]');
    if (buyBtn) buyBtn.addEventListener('click', function () {
      if (!variant.available) return;
      var go = CS.Cart.qty(variant.id) !== sel ? CS.setQty(variant.id, sel) : Promise.resolve();
      CS.openDialog(CS.miniCart);
      Promise.resolve(go).catch(function () {});
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variant.available) return;
      if (CS.Cart.qty(variant.id) === sel) {
        var tip = $('.pd__tip');
        tip.classList.add('is-shown');
        clearTimeout(tip.hideTimer);
        tip.hideTimer = setTimeout(function () { tip.classList.remove('is-shown'); }, 1800);
        return;
      }
      CS.setQty(variant.id, sel, mainImg && mainImg.tagName === 'IMG' ? mainImg : null);
    });

    var mine = ++token;
    CS.onCart(function () { if (mine === token) refresh(); });

    select(variant, false);
    var current = $$('[data-pd-thumb]').map(function (b) { return b.getAttribute('aria-current'); }).indexOf('true');
    inkTo(current > -1 ? current : 0);
    warmSoon();
  };

  if (window.CS) start();
  else document.addEventListener('cs:ready', start, { once: true });

  var SWAP_PARTS = '.pd__stage,.pd__thumbs,.pd__title,.pd__price,.pd__unit,.pd__desc,.pd__form,.pd__pay,.pd-tabs,.pd-acc,.nut,.bundle,.pd-side';
  var busy = null;

  var swap = function (url, push) {
    var root = pdRoot();
    if (!root || !root.dataset.sectionId) { window.location.href = url; return; }
    if (busy) busy.abort();
    busy = 'AbortController' in window ? new AbortController() : null;
    root.classList.add('waiting');
    Array.prototype.forEach.call(root.querySelectorAll(SWAP_PARTS), function (el) { el.classList.add('sk'); });
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(root.dataset.sectionId), { credentials: 'same-origin', signal: busy ? busy.signal : undefined })
      .then(function (res) {
        if (!res.ok) throw new Error('section ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pd-root]');
        if (!fresh) { window.location.href = url; return; }
        root.parentNode.replaceChild(fresh, root);
        if (push) window.history.pushState({ pd: true }, '', url);
        if (window.CS && window.CS.stats) window.CS.stats.viewFromPath();
        var name = fresh.querySelector('.pd__title');
        if (name) {
          var suffix = document.title.indexOf('|') > -1 ? document.title.slice(document.title.indexOf('|')) : '';
          document.title = name.textContent.replace(/\s+/g, ' ').trim() + (suffix ? ' ' + suffix : '');
        }
        var CS = window.CS;
        if (CS) CS.watchImages(fresh);
        start();
        if (CS) CS.syncAll();
      })
      .catch(function (err) { if (!err || err.name !== 'AbortError') window.location.href = url; });
  };

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a.size-option');
    if (!link || !link.getAttribute('href')) return;
    var root = pdRoot();
    if (!root || !root.contains(link)) return;
    e.preventDefault();
    swap(link.href, true);
  });

  window.addEventListener('popstate', function () {
    var root = pdRoot();
    var here = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!root || !here) return;
    var scope = root.querySelector('[data-handle]');
    if (scope && scope.dataset.handle === here[1]) return;
    swap(window.location.href, false);
  });
})();
